import SearchJobPricing from "./../Search/index";
import styles from "./SearchFilters.module.scss";
import ChooseCountry from "../ChooseCountry";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { PopularSearches, RecentSearches } from "../PopularSearches";
import { useNavigate } from "react-router-dom";
import Loader from "../../loader";
import {
  JobPricingHeaderDetails,
  JobPricingReportViewBy
} from "../../../helpers/models/JobPricingDetailModels";
import { updateJobPricingPayloads } from "../../../store/slices/jobPricingSearchSlice";
import {
  setReturnToDataList,
  updateReportHeaderDetails,
  updateReportViewBy
} from "../../../store/slices/jobPricingDetailsSlice";
import { useEffect } from "react";
import { getCurrencyListThunk } from "../../../store/slices/currencyDetailsSlice";
import { RootState } from "../../../store/reducers";
import { configThunk, setList } from "../../../store/slices/configSlice";
import { resetJobCatogery, resetSelectedPeerGroup } from "../../../store/slices/SJPR/listSlice";
import { PAGE_URL } from "../../../constants/urls.constants";
import { updateLandingSearchApiFailed } from "../../../store/slices/jobPricingSlice";

const SearchFilters = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const { selectedCountry, countryError , isSJPR} = useSelector((state: RootState) => {
    return state.country;
  });
  const { currencyList } = useSelector((state: RootState) => {
    return state.currency;
  });
  const { isConfigLoading } = useSelector((state: RootState) => {
    return state.config;
  });
  const { isLandingSearchApiFailed } = useSelector(
    (state: RootState) => state.jobpricing
  );

  const isGradesSequential = (grades: string[]) => {
    for (let i = 1; i < grades.length; i++) {
      if (Number(grades[i]) !== Number(grades[i - 1]) + 1) {
        return false;
      }
    }
    return true;
  };


  useEffect(() => {
    console.log("isSJPR", isSJPR);
  }, [isSJPR]);
  const getDisplayGradeSpan = (gradeList: string[]) => {
    if (gradeList.length > 1 && isGradesSequential(gradeList)) {
      return gradeList[0] + " - " + gradeList[gradeList.length - 1];
    } else {
      return gradeList
        .sort((a: any, b: any) => a.match(/\d+/) - b.match(/\d+/))
        .join(", ");
    }
  };

  const updateReportPricingViewBy = (item: any) => {
    if (!item?.searchCat) return JobPricingReportViewBy.JOB;
    if (item.searchCat === JobPricingReportViewBy.JOB) {
      return JobPricingReportViewBy.JOB;
    } else if (item.searchCat === JobPricingReportViewBy.FUNCTION) {
      return JobPricingReportViewBy.FUNCTION;
    } else if (item.searchCat === JobPricingReportViewBy.GRADE) {
      return JobPricingReportViewBy.GRADE;
    } else {
      return JobPricingReportViewBy.JOB;
    }
  };

  const updateReportPricingHeaderDetails = (item: any) => {
    const updatedPricingPayloads = {
      searchCategory: updateReportPricingViewBy(item),
      jobKey: (item?.jobKey || "ALL").toString(),
      jobOrgCode: (item?.jobOrgCode || "ALL").toString(),
      jobName: item?.jobName || "ALL",
      jobDescription: item?.jobDescription || "ALL",
      jobFamilyName: item?.jobFamilyName || "ALL",
      jobSubFamilyName: item?.jobSubFamilyName || "ALL",
      marketJobFamily: (item?.jobFamilyKey || "ALL").toString(),
      marketJobSubFamily: (item?.jobSubFamilyKey || "ALL").toString(),
      totalJobs: item?.totalJobs || "0",
      jobsInOrg: item?.jobsInOrg || "0",
      gradeId: (item?.gradeId || "ALL").toString(),
      gradeSpan: item?.gradeSpan || "ALL",
      searchTerm: item?.searchTerm || ""
    };
    const pricingHeaderDetails = {
      title: item?.jobName || "-",
      description: item?.jobDescription || "",
      function: item?.jobFamilyName || "-",
      grade: item?.gradeId || "-",
      gradeSpan: item?.gradeId
        ? getDisplayGradeSpan(item.gradeId.split(","))
        : "-",
      jobCode: item?.jobOrgCode || "0",
      subFunction: item?.jobSubFamilyName || "-",
      totalJobs: item?.totalJobs || "0",
      orgJobs: item?.jobsInOrg || "0"
    } as JobPricingHeaderDetails;
    dispatch(updateJobPricingPayloads(updatedPricingPayloads));
    dispatch(updateReportHeaderDetails(pricingHeaderDetails));
  };

  const redirectToJobPricingDetails = (data: any) => {
    dispatch(setReturnToDataList(false));
    dispatch(updateReportViewBy(updateReportPricingViewBy(data)));
    updateReportPricingHeaderDetails(data);
    history(PAGE_URL.JOB_PRICING_DETAILS);
  };

  const handleCloseApiFailedMsg = () => {
    dispatch(updateLandingSearchApiFailed(false));
  };

  useEffect(() => {
    dispatch(resetJobCatogery());
    dispatch(resetSelectedPeerGroup());
    if (!currencyList || currencyList.length === 0) {
      dispatch(getCurrencyListThunk({}));
    }
  }, []);

  useEffect(() => {
    if (selectedCountry?.key) {
      dispatch(
        configThunk({
          countryCode: selectedCountry.key,
          language: "en",
          year: new Date().getFullYear()
        })
      );
    } else {
      dispatch(setList([]));
    }
  }, [selectedCountry?.key]);

  return (
    <>
      {/* // <NoDataScreen /> */}
      {countryError || !isSJPR ? (
        <div className={`${styles.noAccess}`}>
          {t("pa.userDontHaveAccess")}
          </div>
      ) : (
        <div className={`${styles.SearchContainer}`}>
          {/* <p> Search Component</p>
      <p> All Filters </p>
      <p> choose Country Component</p> */}
          <span className={styles.title}>{t("pa.sjpr.title")}</span>
          <span className={styles.subtext}>{t("pa.sjpr.subText")}</span>

          <ChooseCountry />
          <SearchJobPricing />

          <div className={styles.helpertext}>
            {t("pa.sjpr.search.description1")}
            <a
              className={styles.helpertexthyper}
              onClick={() =>
                selectedCountry?.key &&
                history("/sjpr/job-search-results")
              }
              style={{
                color: !selectedCountry?.key ? "#808080" : "#008369",
                cursor: !selectedCountry?.key ? "default" : "pointer"
              }}
            >
              {t("pa.sjpr.search.description2")}
            </a>
          </div>
          {isConfigLoading ? (
            <Loader />
          ) : (
            selectedCountry?.key && (
              <div className={styles.recentSearchBlock}>
                <PopularSearches
                  showDetails={(data: any) => {
                    redirectToJobPricingDetails(data);
                  }}
                />
                <RecentSearches
                  showDetails={(data: any) => {
                    redirectToJobPricingDetails(data);
                  }}
                />
              </div>
            )
          )}
          <Snackbar
            open={isLandingSearchApiFailed}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={3000}
            onClose={handleCloseApiFailedMsg}
          >
            <Alert
              onClose={handleCloseApiFailedMsg}
              severity="error"
              sx={{ width: "100%" }}
            >
              {t("pa.sjpr.serviceApiFailedMsg")}
            </Alert>
          </Snackbar>
        </div>
      )}
    </>
  );
};

export default SearchFilters;
